var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PA"},[_c('PublicCert',{attrs:{"logo":_vm.Logo2,"type":'pa',"color":'#2b257b'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }